module.exports = __webpack_public_path__ + "static/media/Mini Project EXTC 20-21.67a45999.pdf";